import { createLinesAnimation } from './createLinesAnimation';
import { useEffect, useRef } from 'react';

const RESIZE_DELAY = 100;

export const useAnimation = canvasRef => {
    const animation = useRef(null);
    useEffect(
        () => {
            animation.current = createLinesAnimation(canvasRef.current);
            animation.current.start();

            let resizeDelayTimer;
            const onResize = () => {
                clearTimeout(resizeDelayTimer);
                animation.current.stop();
                animation.current.resize();
                resizeDelayTimer = setTimeout(
                    animation.current.start,
                    RESIZE_DELAY
                );
            };

            window.addEventListener('resize', onResize);

            return () => {
                clearTimeout(resizeDelayTimer);
                window.removeEventListener('resize', onResize);
                animation.current.stop();
            };
        },
        [canvasRef]
    );
};
